import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { isAuthenticatedGuard } from '@core/guards/is-authenticated.guard';
// import { isSessionGuard } from '@core/guards/is-session.guard';
import { isAuth } from '@core/guards/is-auth.guard';
import { urlTokenGuard } from '@core/guards/url-token.guard';
import { SharedLayoutComponent } from '@shared/layout/shared-layout/shared-layout.component';
import { DashboardWhatsappComponent } from '@modules/lead-management/submodules/statistics/components/dashboard-whatsapp/dashboard-whatsapp.component';
import REPORTS_ROUTES from '@modules/reports/reports.routes';

const routes: Routes = [
  {
    path: 'dashboard',
    component: DashboardWhatsappComponent,
  },
  {
    path: 'auth',
    canActivateChild: [isAuth],
    loadChildren: () =>
      import('@modules/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'mdm',
    loadChildren: () =>
      import('@modules/mdm/mdm.module').then((m) => m.MdmModule),
  },
  {
    path: 'cotizaciones',
    loadChildren: () =>
      import('@modules/cotizaciones/cotizaciones-routing.module').then(
        (m) => m.CotizacionesRoutingModule
      ),
  },
  {
    path: 'configuration-ia',
    canActivate: [urlTokenGuard],
    loadChildren: () =>
      import('@modules/configuration-ia/configuration-ia.module').then(
        (m) => m.ConfigurationIaModule
      ),
  },
  {
    path: 'internal-configuration',
    loadChildren: () =>
      import('@modules/internal-configuration/internal-configuration.module').then((m) => m.InternalConfigurationModule),
  },
  {
    path: 'ia-access',
    loadChildren: () =>
      import('@modules/ia-access/ia-access.module').then(
        (m) => m.IaAccessModule
      ),
  },
  {
    path: 'tokens-ai',
    loadChildren: () =>
      import('@modules/tokens-ai/tokens-ai.module').then(
        (m) => m.TokensAIModule
      ),
  },
  {
    path: 'client-tokens',
    loadChildren: () =>
      import('@modules/client-tokens/client-tokens.module').then(
        (m) => m.ClientTokensModule
      ),
  },
  // {
  //   path: 'bot-ia-example',
  //   loadChildren: () =>
  //     import('@features/bot-ia-EXAMPLE/bot-ia.module').then(
  //       (m) => m.BotIAModule
  //     ),
  // },
  {
    path: 'session-expired',
    loadComponent: () =>
      import('@features/session-expired/session-expired.component').then(
        (m) => m.SessionExpiredComponent
      ),
  },
  ...REPORTS_ROUTES,
  {
    path: '',
    // canActivateChild: [isSessionGuard],
    component: SharedLayoutComponent,
    children: [
      {
        path: 'reception',
        canActivateChild: [isAuthenticatedGuard],
        loadChildren: () =>
          import('@modules/reception/reception.module').then(
            (m) => m.ReceptionModule
          ),
      },
      {
        path: 'marketing',
        canActivateChild: [isAuthenticatedGuard],
        loadChildren: () =>
          import('@modules/marketing/marketing-.module').then(
            (m) => m.MarketingModule
          ),
      },
      {
        path: 'settings',
        canActivateChild: [isAuthenticatedGuard],
        loadChildren: () =>
          import('@modules/settings/settings.module').then(
            (m) => m.SettingsModule
          ),
      },
      {
        path: 'notifications',
        canActivateChild: [isAuthenticatedGuard],
        loadChildren: () =>
          import('@modules/notifications/notifications.module').then(
            (m) => m.NotificationsModule
          ),
      },
      {
        path: 'multicanal',
        canActivateChild: [isAuthenticatedGuard],
        loadChildren: () =>
          import('@modules/multicanal/multicanal.module').then(
            (m) => m.MulticanalModule
          ),
      },
      {
        path: 'lead-management',
        loadChildren: () =>
          import('@modules/lead-management/lead-management.module').then(
            (m) => m.LeadManagementModule
          ),
      },
      { path: '', pathMatch: 'full', redirectTo: 'lead-management/home' },
      { path: '**', redirectTo: 'auth/login' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule {

}
